export default "__VITE_ASSET__DTcG9NzS__"